<template>
  <component 
    :is="currentComponent" 
    :mapTotalToTitle="mapTotalToTitle"
    v-bind="$attrs"
  />
</template>

<script>
import VisitesList from './VisitesList.vue'
import ParcimmoList from './ParcimmoList.vue'
import ActionsList from './ActionsList.vue'

export default {
  name: 'ListView',
  components: {
    VisitesList,
    ParcimmoList,
    ActionsList
  },
  props: {
    subject: {
      type: String,
      required: true,
      validator: (value) => ['visites', 'parcimmo', 'actions'].includes(value)
    },
    mapTotalToTitle: {
      type: Function,
      default: (total) => (loading) => loading ? 'Chargement...' : `${total} éléments`
    }
  },
  computed: {
    currentComponent() {
      switch (this.subject) {
        case 'visites':
          return 'VisitesList'
        case 'parcimmo':
          return 'ParcimmoList'
        case 'actions':
          return 'ActionsList'
        default:
          return 'VisitesList'
      }
    }
  }
}
</script>

<style lang="scss">
@use './../assets/styles/components/List.scss';
</style>
